import { useEffect } from "react";
import { useMultiCashoutEnabled } from "../../../hooks/useMultiCashoutEnabled";
import { ROUTES } from "../../../setup/constants";
import { useNavigate } from "react-router-dom";
import MultiCashoutDetails from "./MultiCashoutDetails";
import Spinner from "../../../components/common/Spinner";
import styles from "./styles.module.scss";

const MultiCashoutDetailsPage = () => {
  const { isMultiCashoutEnabled, isLoadingMultiCashoutFlag } =
    useMultiCashoutEnabled();

  const navigate = useNavigate();

  useEffect(() => {
    if (!isMultiCashoutEnabled && !isLoadingMultiCashoutFlag) {
      navigate(ROUTES.CONTRACT_NOT_FOUND, { replace: true });
    }
  }, [isLoadingMultiCashoutFlag, isMultiCashoutEnabled, navigate]);

  if (isLoadingMultiCashoutFlag) {
    return (
      <div className={styles.loading_container}>
        <Spinner />
      </div>
    );
  }

  if (!isMultiCashoutEnabled) {
    return null;
  }
  return <MultiCashoutDetails />;
};

export default MultiCashoutDetailsPage;
